import qs from 'qs';
const logger = useLogger('middleware/aisRestoreFilter');

export default defineNuxtRouteMiddleware(async (to, from) => {
    if (import.meta.server) return;

    if(useActionHistory()?.value?.at(-1) == 'SearchUsed') return;

    const aisMeta = to?.meta?.['ais'] as { query: string, path: string };
    const filter = aisMeta?.query ?? '';
    const path = aisMeta?.path ?? '';
    if (from?.name === 'pds' && path === to.path && filter.length > 0) {
        logger.debug({
            fromPath: from.path,
            toPath: to.path,
            aisData: to?.meta?.['ais'],
        });

        const decodedString = qs.stringify(to.query, {
            addQueryPrefix: true,
            arrayFormat: "repeat",
            format : 'RFC1738',
            encode: true,
        });

        if (`${decodedString}` !== `${filter}`) {
            return navigateTo(`${to.path}${filter}`);
        }
    }
});
